import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap';
import { ListPromotionalAddon, buyPromotionalAddonPlan, getAvailableCredit } from '../../../Context/api';
import Spinner from '../../../Components/spinner/spinner'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import { commonMessage, statusCodes } from '../../../Constants/generalConfig'

const PromotionalAddon = () => {
    const [spinner, setSpinner] = useState(false)
    const [promotionalAddonDataData, setPromotionalAddonData] = useState([])
    const navigate = useNavigate()
    const userData = JSON.parse(localStorage.getItem('userData'))
    const [showModal, setShowModal] = useState(false);
    const [creditLimit, setcreditLimit] = useState(false);
    const [selectedPlanId, setSelectedPlanId] = useState(null);

    useEffect(() => {
        getAvailableCreditLimit()
        list()
    }, [])

    const getAvailableCreditLimit = () => {
        const data = {
            id: userData?.providerId,
        }
        setSpinner(true)
        axios.post(getAvailableCredit(), { ...data }, { headers: { Authorization: `Bearer ${userData?.token}` } })
            .then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    setcreditLimit(resp.data.data.messageCreditLimit)
                } else {
                    setSpinner(false)
                }
            })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }

    const list = () => {
        setSpinner(true)
        axios.post(ListPromotionalAddon(), { isActive: true, isDeleted: false }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setPromotionalAddonData(resp.data.data)
                setSpinner(false)
            } else {
                setSpinner(false)
                setPromotionalAddonData([])
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }

    const buyPlan = (id) => {
        const planObj = {
            providerId: userData?.providerId,
            countryCode: userData?.currencyCode,
            planId: id
        }
        setSpinner(true)
        axios.post(buyPromotionalAddonPlan(), planObj, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                window.open(resp?.data?.data?.url)
                setSpinner(false)
            } else {
                setSpinner(false)
                setPromotionalAddonData([])
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }

    return (
        <>
            <ToastContainer />
            <section>
                {spinner && <Spinner />}
                <div className="m-t-3 cus-padd cusheight">
                    <header>
                        <div className="d-flex flex-column flex-md-row justify-content-between">
                            <h2 className="page-tittle mb-2 mb-md-0">
                                <i className="fa-solid fa-angle-left cusgap cursor me-2" onClick={() => navigate(-1)}></i>
                                Promotional Add-ons Plan
                            </h2>
                            <h1 className="page-tittle">
                                <u className='text-primary cursor' style={{ fontSize: '15px' }} onClick={() => navigate(`/layout/setting/my-plan/my-plan-history/3/${userData?.currencySymbol}`)}>
                                    Promotional Plan History
                                </u>
                            </h1>
                        </div>
                        <hr />
                    </header>
                    <div className="row">
                        <div className="text-start mb-3">
                            Available Credits: <span style={{ color: '#F47D3A' }}> <strong>{creditLimit}</strong></span>
                        </div>
                        <div className="col-sm-12 listpadding">
                            <div className='row'>
                                {
                                    promotionalAddonDataData?.map((item, index) => {
                                        const randomBgColor = `hsl(${Math.floor(Math.random() * 360)}, 100%, 90%)`;

                                        return (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4" key={index}>
                                                <div
                                                    className="promotionalCss h-100 d-flex flex-column justify-content-between"
                                                    style={{
                                                        border: "1px solid #DBDBDB",
                                                        borderRadius: "24px",
                                                        backgroundColor: "#fff",
                                                        overflow: "hidden",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <div className="card-body p-3 d-flex flex-column">
                                                        <div
                                                            className="rounded-3 p-3 mb-3 text-center"
                                                            style={{ backgroundColor: item.bgColor || randomBgColor }}
                                                        >
                                                            <h5 className="mb-0 fw-bold">{item.name}</h5>
                                                        </div>
                                                        <p className="text-muted small flex-grow-1" style={{ minHeight: '85px' }}>
                                                            {item.description}
                                                        </p>
                                                        <hr />
                                                        <div className="d-flex justify-content-between align-items-center mt-auto">
                                                            <div>
                                                                <h5 className="mb-1 fw-bold">
                                                                    {userData.currencyCode === 'INR' ? '₹' : '$'} {item.price}/-
                                                                </h5>
                                                                <span className="text-muted small">
                                                                    Credits: <span style={{ color: '#F47D3A' }}>{item.credit}</span>
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn buyPromotionalbtn"
                                                                onClick={() => {
                                                                    setSelectedPlanId(item._id);
                                                                    setShowModal(true);
                                                                }}
                                                            >
                                                                Buy
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                        <div className="p-3 pb-0 border-bottom d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Confirm Purchase</h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => setShowModal(false)}
                            ></button>
                        </div>
                        <Modal.Body className="text-start p-4">
                            <p>Are you sure you want to buy this promotional plan?</p>
                            <div className="d-flex justify-content-center mt-4 gap-2">
                                <button type="button" className="btn nobtn" onClick={() => setShowModal(false)}>
                                    No
                                </button>
                                <button type="button" className="btn yesbtn" onClick={() => {
                                    buyPlan(selectedPlanId);
                                    setShowModal(false);
                                }}>
                                    Yes
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </section>

            
        </>
    )
}

export default PromotionalAddon
